import { render, staticRenderFns } from "./RevenueSplitView.vue?vue&type=template&id=1993b365&scoped=true"
import script from "./RevenueSplitView.vue?vue&type=script&lang=js"
export * from "./RevenueSplitView.vue?vue&type=script&lang=js"
import style0 from "./RevenueSplitView.vue?vue&type=style&index=0&id=1993b365&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1993b365",
  null
  
)

export default component.exports